import { c as _c } from "react/compiler-runtime";
import ExclamationDisc from '@/components/Icons/ExclamationDisc';
import styled from 'styled-components';
export const ERROR_MESSAGES = {
  ACCESS_DENIED: 'Access was denied by the login provider, most likely due to an incorrect password. Please check or reset your credentials and try again.',
  DISALLOWED_EMAIL: 'Sorry, we are unable to share with this email account at this time. Please contact an account manager.',
  NOT_AUTHORIZED_ERROR: 'Your account has not been authorized. Please try again or contact support.',
  USER_NOT_FOUND_ERROR: 'User not found. Please try again or contact support.',
  INVALID_CODE: 'The code that was entered was invalid. Please try again or request a new code.',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Please wait a while before trying again.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  INVALID_CORPORATE_EMAIL: 'Please enter a valid corporate email address.',
  INVALID_TOKEN: 'The provided login token has expired or was previously used. Please login again.',
  NO_COOKIE: 'Login timed out. Please try again. Ensure cookies are enabled in your browser and your computer is set to the correct time.',
  BAD_REQUEST: 'Invalid input data provided. Please try again. If issues persist, contact support.',
  MISSING_EMAIL_ERROR: 'The email address was not found. Please try again or contact your account manager.',
  MISMATCHED_STATE: 'There was an issue during authentication, most likely caused by duplicate open tabs. Please login again here.',
  MISMATCHED_UUID_ERROR: 'This email address could not be reconciled to an individual account. Please contact your account manager.',
  DUPLICATE_USER_ERROR: 'This email address could not be reconciled to an individual account. Please contact your account manager.',
  INACTIVE: 'Your account is not enabled. Please contact your account manager.',
  UNSUPPORTED_DOMAIN_ERROR: 'This email is not enabled. Please contact your account manager.',
  SHARE_LIMIT: 'Sorry, it seems that your colleague has reached their sharing limit.',
  SIGNUP_EMAIL_SEND_ERROR: 'We were unable to send the signup email. Please contact your account manager.',
  VERIFICATION_EMAIL_SEND_ERROR: 'We were unable to send a verification code to this email address. Please try a different address.',
  SESSION_EXPIRED: 'You have been logged out because your session has expired or you have logged in via another browser.',
  RESET_COMPLETE: 'You may now login with your new password.',
  TRIAL_AGREEMENT_NOT_FOUND: 'Your trial agreement has expired. Please contact an account manager.',
  UNKNOWN_ERROR: 'A server error has occurred. Please try again. If issues persist, contact support.'
} as {
  [key: string]: string;
};
export const LoginErrorMessage = t0 => {
  const $ = _c(15);
  const {
    errorKey
  } = t0;
  if (!errorKey) {
    return null;
  }
  let T0;
  let T1;
  let parts;
  let t1;
  let t2;
  if ($[0] !== errorKey) {
    parts = errorKey.split(":");
    T1 = StyledError;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Icon><ExclamationDisc /></Icon>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    T0 = Message;
    t1 = ERROR_MESSAGES[parts[0].toUpperCase()] || ERROR_MESSAGES.UNKNOWN_ERROR;
    $[0] = errorKey;
    $[1] = T0;
    $[2] = T1;
    $[3] = parts;
    $[4] = t1;
    $[5] = t2;
  } else {
    T0 = $[1];
    T1 = $[2];
    parts = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const t3 = parts[1] ? ` (${parts[1]})` : "";
  let t4;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t3) {
    t4 = <T0>{t1}{t3}</T0>;
    $[7] = T0;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== T1 || $[12] !== t2 || $[13] !== t4) {
    t5 = <T1>{t2}{t4}</T1>;
    $[11] = T1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
const StyledError = styled.div`
    width: 100%;
    padding: var(--size-grid-unit);
    /* Match the BSSO error message colors */
    background: var(--cds-color-warningpanel-background-idle);
    color: var(--cds-color-warningpanel-text);
    display: flex;
    align-items: center;
    font-weight: bold;
`;
const Icon = styled.div`
    width: 1.4em;
    height: 1.4em;
    margin-right: var(--size-grid-unit);
`;
const Message = styled.p`
    flex: 1;
`;